import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React from "react";
import styled from "styled-components";

import { SCROLL_MARKS } from "@faire/retailer/features/EvergreenPreorderVisibility/brandPageScrollUtils";
import { useTopOfPageContentStore } from "@faire/retailer/stores/ui/TopOfPageContentStore";

export const FakeAnchor: React.FC<{ id: SCROLL_MARKS | string }> = ({ id }) => {
  useTraceComponentRender("FakeAnchor");
  const { headerPlusPromoBannerHeight: actualHeight } =
    useTopOfPageContentStore(["headerPlusPromoBannerHeight"]);
  const isSSR = useIsSSR();
  const height = isSSR ? 0 : actualHeight;
  const [top, setTop] = React.useState(`-${height}px`);

  // using a state instead the observable value because the latter is updated
  // at a rendering time which is causing some warnings
  React.useEffect(() => {
    setTop(`-${height}px`);
  }, [height]);

  return <StyledDiv id={id} $top={top} />;
};

const StyledDiv = styled.div<{ $top: string }>`
  visibility: hidden;
  position: relative;
  top: ${(props) => props.$top};
`;
